<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Internship</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Internship</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="ptb--100 ">
  <div class="container">
    <div class="row justify-content-center gx-4">
      <div class="col-md-12">
        <h4 class="yellow-color fw-bold">Internship at GHRCACS</h4>
        <blockquote class="blockquote-div mt-4">
          <p>The expert in anything was once a beginner.
          </p>
          <h6>- Anonymous</h6>
        </blockquote>
        <p>This is exactly the school of thought which is continuously being practiced here at the G H Raisoni College
          Of Arts, Commerce And Science.We believe in nurturing students with knowledge and skills and inculcating in
          them leadership qualities.</p>
        <p>Amidst a plethora of steps taken by us in this journey, internship is a leap towards better accomplishments
          of our students.</p>
        <h4 class="yellow-color fw-bold">What does the internship include?</h4>
        <p>It is a well planned work experience associated with enhancing the personal development and academic career
          of a student. The management and direction for the same is pursued by the expert in the field in the
          industries. The students are on the receiving end of live exposure. They are able to witness the problems in
          the work field and find it’s first hand solution all by themselves.</p>
        <p>We at the GHRCACS have the following norms taken care of in the realm of internship:-</p>
        <ul class="list-before">
          <li><strong>Compulsory -</strong> We completely believe in the significance internship has in framing the
            career growth of the students. Thus, in accordance with our curriculum it is mandatory for all the students
            pursue summer internship in the 6th Semester.</li>
          <li><strong>Tenure -</strong> The tenure of this internship is so designed that it encompasses the finest of
            work experience, enhancing of the skills and knowledge about the subject. It is for a period of one month.
          </li>
          <li><strong>Post internship -</strong> Post the internship, the students are required to pursue a presentation
            in the Department which is required to be in a proper format. Grades/marks are provided to the students
            pertaining to their presentation and findings.</li>
          <li><strong>Certification -</strong> The certificate which the students gain after the completion of the
            internship is of immense significance. It portrays their work experience and is provided by the industry.
          </li>
          <li><strong>Job benefits -</strong> There have been many instances wherein postcompletions of the internship,
            the students have job/service offers from the same industry. Yet again, the industry based project is
            offered to the students in the final year on the basis of the internship to the students. The latter is
            indispensable for their better grades. There are also the MOUs or the Memorandum of Understanding which
            directs the students to pursue better. It gives them ample benefits in the field with priority.</li>
          <li><strong>Workshops -</strong> Round the year industry workshops are held to foster the talents of the
            students and to make the proficient pertaining to their subjects.</li>
        </ul>
        <p>At the GHRCACS every step you take brings you closer to your accomplishments.</p>
      </div>
    </div>
  </div>
</section>
